import React from 'react';
import LandingPage from './components/LandingPage';
import './App.css';
import './styles/Responsive.css'; // Add this import

function App() {
  return (
    <div className="App">
      <LandingPage />
    </div>
  );
}

export default App;
